import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { VehicleOdometerChangeReasonEnum } from '../enums/vehicle-odometer-change-reason.enum';

/**
 * Delete vehicle odometer tracking DTO
 */
export class DeleteVehicleOdometerTrackingDto {
	sourceSubject!: AppSubjectEnum;
	@TransformInt()
	sourceId!: number;
	changeReason?: VehicleOdometerChangeReasonEnum;
	@TransformInt()
	changeReferenceId?: number;
}
